import { Component, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  MatTableDataSource,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
} from '@angular/material/table';
import { first } from 'rxjs';
import {
  LawFirmItem,
  LawFirmService,
} from 'src/app/services/law-firm/law-firm.service';
import { CreateLawFirmDialogComponent } from './create-law-firm-dialog/create-law-firm-dialog.component';
import { UpdateLawFirmDialogComponent } from './update-law-firm-dialog/update-law-firm-dialog.component';
import { DeleteLawFirmDialogComponent } from './delete-law-firm-dialog/delete-law-firm-dialog.component';
import { SetMokkCookieDialogComponent } from './set-mokk-cookie-dialog/set-mokk-cookie-dialog.component';
import { PayeeButtonComponent } from '../../../shared/payee-buttons/payee-button/payee-button.component';
import { PayeeMiniIconButtonComponent } from '../../../shared/payee-buttons/payee-mini-icon-button/payee-mini-icon-button.component';
import { PayeeIconComponent } from '../../../shared/payee-icon/payee-icon.component';

@Component({
  selector: 'app-law-firms',
  templateUrl: './law-firms.component.html',
  styleUrls: ['./law-firms.component.scss'],
  imports: [
    PayeeButtonComponent,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    PayeeMiniIconButtonComponent,
    PayeeIconComponent,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
  ],
})
export class LawFirmsComponent implements OnInit {
  private dialog = inject(MatDialog);
  private lawFirmService = inject(LawFirmService);

  readonly dataSource = new MatTableDataSource<LawFirmItem>();
  readonly displayedColumns = ['name', 'mokk_cookie', 'edit', 'delete'] as const;

  async ngOnInit() {
    await this.setLawFirms();
  }

  createLawFirm(): void {
    const ref = this.dialog.open(CreateLawFirmDialogComponent);

    ref
      .afterClosed()
      .pipe(first())
      .subscribe(async (result?: LawFirmItem) => {
        if (result) {
          this.dataSource.data = this.dataSource.data.concat(result);
        }
      });
  }

  editLawFirm(lawFirm: LawFirmItem): void {
    this.dialog.open(UpdateLawFirmDialogComponent, { data: lawFirm });
  }

  setMokkCookie(lawFirm: LawFirmItem): void {
    this.dialog.open(SetMokkCookieDialogComponent, { data: lawFirm });
  }

  deleteLawFirm(lawFirm: LawFirmItem): void {
    const ref = this.dialog.open(DeleteLawFirmDialogComponent, {
      data: lawFirm,
    });

    ref
      .afterClosed()
      .pipe(first())
      .subscribe(async (result?: boolean) => {
        if (result) {
          const index = this.dataSource.data.indexOf(lawFirm);
          if (index >= 0) {
            this.dataSource.data.splice(index, 1);
            this.dataSource.data = [...this.dataSource.data];
          }
        }
      });
  }

  private async setLawFirms(): Promise<void> {
    try {
      this.dataSource.data = await this.lawFirmService.listLawFirms();
    } catch (error: unknown) {
      console.error('Error while loading law firms', error);
    }
  }
}
